<template>
    <div class="table-sec">
        <div class="table-responsive">
            <table class="table table-border-none">
                <thead>
                    <tr>
                        <th>Year</th>
                        <th>Investment</th>
                        <th>Interest</th>
                        <th>Balance</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(yearData, index) in AmortizationsByYear" v-if="yearData" :key="index">
                        <td>{{ yearData[0].Year }}</td>
                        <td>{{ formatFigure(yearData[0].Principal) }}</td>
                        <td class="interest-val">{{ formatFigure(yearData[0].Interest) }}</td>
                        <td>{{ formatFigure(yearData[0].Total) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    import Accounting from 'accounting';

    export default {
        props: {
            amortizationsByYear: {
                default() {
                    return [];
                },
            },
        },
        data() {
            return {
                AmortizationsByYear: this.amortizationsByYear,
            };
        },
        methods: {
            formatFigure(figure) {
                return Accounting.formatMoney(figure, { symbol: '$', precision: 2 });
            },
        },
    };
</script>
<style lang="scss">
@import "../../../assets/styles/v2/variables";
#lt-yantr-v2.investment-calc {
    /* Table Style */
    .table-sec {
        margin: 30px auto 0;

        @media #{$md-up} {
            width: 700px;
            margin-top: 50px;
        }
    }

    .table {
        width: 100%;
        border-collapse: collapse;

        thead th {
            background: $azure;
        }

        th,
        td {
            text-align: right;
            width: 30%;

            &:first-child {
                text-align: left;
                width: 10%;
            }
        }

        th {
            font-size: $fs-10;
            color: $grey-day;
            text-transform: uppercase;
        }

        td {
            color: $brand-dark-blue;
            font-weight: $fw-bold;

            &.interest-val {
                color: $brand-green;
            }
        }

        tbody tr {
            border-top: $primary-br;

            &:first-child {
                border-top: none;
            }
        }
    }
}
</style>
